export default __webpack_public_path__ + "static/media/76.4230a65a.png";